
import { animate, state, style, transition, trigger } from '@angular/animations';
import { AfterContentChecked, AfterViewChecked, AfterViewInit, ChangeDetectionStrategy, Component, ElementRef, EventEmitter, Input, OnInit, Output, ViewChild, inject } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA, MatDialogModule } from '@angular/material/dialog';
import { MatButtonModule } from '@angular/material/button';
import { CommonModule } from '@angular/common';
import { SpaceBeforeCapPipe } from '../../../../../pipes/space_before_capitial.pipe';
import {MAP_INSTANCE, provideOlMap} from '@aetherion/spatial'
import { PluggableMap, View } from 'ol';

import LayerGroup from 'ol/layer/Group';

import OlMap from 'ol/Map';

import { base_map_defs } from 'src/app/_helpers/basemaps';
import { versatilityGradientColors } from 'src/app/_helpers/layer.styles';
import { populateLayerGroup } from 'src/app/_helpers/LayerBuilder';
import { mapProjEPSG } from 'src/app/_helpers/projection_setup';
@Component({
    selector: 'app-dss-map-overlay',
    templateUrl: './dss-map-overlay.component.html',
    styleUrls: ['./dss-map-overlay.component.css'],
    standalone: true,
    imports: [CommonModule, MatDialogModule, MatButtonModule, SpaceBeforeCapPipe],
    providers: [provideOlMap({projection: mapProjEPSG, proj4Defs:[{code: 'EPSG:28355', def: '+proj=utm +zone=55 +south +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs' }]})]
})
export class DssMapOverlayComponent implements OnInit,AfterViewInit, AfterViewChecked{
  private elRef = inject(ElementRef);
  dialogRef = inject<MatDialogRef<DssMapOverlayComponent>>(MatDialogRef);
  data = inject(MAT_DIALOG_DATA);
  map = inject(MAP_INSTANCE)
  active = true;
  colorIndex = [];

  basemapGroup = new LayerGroup({
    layers: [],
    title: 'Background Maps',
    fold: 'open',
  } as any);

  @ViewChild('map', {static:true})
  mapElement : ElementRef;

  ngOnInit(): void {

    for (const [key, value] of Object.entries(versatilityGradientColors)) {

      let colorIndex = {
        name: key,
        color: `rgba(${value})`
      }

      this.colorIndex.push(colorIndex);
    }

this.setupBaseMaps();
  }

  setupBaseMaps() {
    if (this.basemapGroup.getLayersArray().length == 0)
      populateLayerGroup(base_map_defs, this.basemapGroup, ()=>{});
    else return;
    //populateLayerGroup(defaultLayers, this.testGroup, this.rebuildLegend);
  }

  ngAfterViewInit(): void {

    this.map.getLayerGroup().getLayers().insertAt(0, this.basemapGroup as any)


    this.map.setTarget(this.mapElement.nativeElement);
    
    this.map.getView().fit(this.data.map.getView().calculateExtent(this.data.map.getSize()));


    this.map.updateSize();

    this.data.layers.forEach(layer => {
      this.map.getLayers().insertAt(1,layer)

      if (layer && layer.getSource) {
        layer.getSource().changed();
      }
    })

    this.map.render();


  }

  ngAfterViewChecked(): void {
    this.map.getView().getZoom() + 1;
    this.map.getView().getZoom() - 1;
  }

}
